<template>
  <dialog-email
    ref="dialog"
    :isLoading="isLoading"
    :contentKey="contentKey"
    :contentMap="contentData"
    :data="data"
    @on-submit-email="handlerSubmit"
  ></dialog-email>
</template>

<script>
import { ServiceEmailMessages } from '@/services/email-messages'

export default {
  name: 'DialogSendTDEmail',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogEmail/index')
  },
  props: {
    id: { required: true }
  },
  data () {
    return {
      isLoading: false,
      data: {},
      contentKey: '',
      contentData: {},
      logoType: null,
      sendPDF: false
    }
  },
  methods: {
    show ({ data, contentKey, contentData, logoType, sendPDF }) {
      this.sendPDF = sendPDF
      this.data = data
      this.contentKey = contentKey
      this.contentData = contentData
      this.logoType = logoType
      this.$refs.dialog.show()
    },
    hide () {
      this.logoType = null
      this.$refs.dialog.hide()
    },
    async handlerSubmit (emailData) {
      this.isLoading = true

      try {
        await ServiceEmailMessages.sendTd({
          id: this.id,
          logoKey: this.logoType,
          isSendPdf: this.sendPDF,
          translate: this.L10n,
          ...emailData
        })

        this.$emit('onSent', emailData)
        this.requestSuccessHandler()
        this.hide()
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
